import * as Yup from "yup";

export default Yup.object({
  primaryRegion: Yup.object().required("Please select your region"),
  language: Yup.object().required("Please select your language"),
});
